import axios from 'axios'
import { attachCsrfInterceptor } from './csrf'
import { BFF_BASE_URL } from './bffBaseUrl'

export const app = axios.create({
    baseURL: BFF_BASE_URL,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

attachCsrfInterceptor(app)
